import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';
import Typography from "@mui/material/Typography";
import Box from '@mui/material/Box';
import { when } from "util/support";
import { getFormInputProps } from 'util/forms';
import { withDetectIncomplete } from "features/ecommerce/helpers";
import { PaymentMethod } from 'features/ecommerce/types';
import { OnboardingPaymentMethod } from "ui/molecules/PaymentMethod";
import { Collection } from "ui/support/Resource";
import When from 'ui/support/When';
import OnboardingForm from "ui/forms/ECommerce/Onboarding/OnboardingForm";
import { OnboardingInputControl } from 'ui/molecules/Input';
import {
    FormField,
    type OnboardingPaymentMethodsProps
} from "./types";

export const PaymentMethods = ({
    values,
    isSubmitting,
    isValid,
    isBootstrapDataLoading,
    isIncomplete,
    requestedChangeFields,
    bootstrapData,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
    handleSubmit,
    ...form
}: OnboardingPaymentMethodsProps) => (
    <OnboardingForm
        {...form}
        isSubmitting={isSubmitting}
        isValid={isValid}
        isIncomplete={isIncomplete}
        requestedChangeFields={requestedChangeFields}
        handleSubmit={handleSubmit}
    >
        {(typeof requestedChangeFields !== 'string') && (
            <When
                if={Boolean(requestedChangeFields)}
                then={() => (
                    <Alert
                        severity='warning'
                    >
                        <>
                            {requestedChangeFields!.comments}
                        </>
                    </Alert>
                )}
            />
        )}
        <Collection
            collection={bootstrapData.methods}
            renderResource={(paymentMethod: PaymentMethod, index) => {
                const tags = values[FormField.Methods];
                const isChecked = tags.includes(paymentMethod.tag);

                return (
                    <OnboardingPaymentMethod
                        {...paymentMethod}
                        key={index}
                        disabled={!withDetectIncomplete(isIncomplete, requestedChangeFields)}
                        checked={isChecked}
                        onChange={() => {
                            when(
                                isChecked,
                                () => setFieldValue(
                                    FormField.Methods,
                                    tags.filter(tag => !Object.is(paymentMethod.tag, tag))
                                ),
                                () => setFieldValue(
                                    FormField.Methods,
                                    [...tags, paymentMethod.tag]
                                )
                            );

                            setTimeout(() => setFieldTouched(FormField.Methods, true, true));
                        }}
                    />
                );
            }}
        />
        <Box
            component='span'
            sx={{
                mt: 2,
                display: 'grid'
            }}
        >
            <Typography
                variant='h6'
                gutterBottom
            >
                Do you use any other Payment Methods?
            </Typography>
            <OnboardingInputControl
                name={FormField.OtherMethods}
                isIncomplete={isIncomplete}
                requestedChangeFields={requestedChangeFields}
                renderInput={({ disabled }) => (
                    <TextField
                        {...getFormInputProps(FormField.OtherMethods, form)}
                        fullWidth
                        required
                        multiline
                        rows={4}
                        disabled={disabled}
                        size='small'
                        name={FormField.OtherMethods}
                        value={values[FormField.OtherMethods]}
                        label='Other Payment Methods'
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                )}
            />
        </Box>
    </OnboardingForm>
);

export default PaymentMethods;
